import { render } from "./dashboard-screen.vue?vue&type=template&id=36755ee9"
import script from "./dashboard-screen.vue?vue&type=script&lang=js"
export * from "./dashboard-screen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__